import * as React from 'react';
import InputHandler from 'Components/InputHandler';
import { fm } from 'Components/FormatMessage';
import type { IExtendedSearchField } from '../ExtendedSearchField';
import Unit from 'Components/Unit';
import { styled } from '@mui/system';

const InlineDiv = styled('div')({
  display: 'inline-flex',
});

const WeightGainField = ({ searchFields, onChange }: IOwnProps): React.JSX.Element => {
  const thisSearchField = searchFields.weightGain !== 'noCropping' ? searchFields.weightGain : undefined;

  const handleChange = (values: TOnChangeValues) => {
    const f = Object.keys(values)[0] as 'threshold' | 'minDurationYears';
    const v = values[f];
    const base =
      typeof thisSearchField === 'object' ? thisSearchField : { threshold: undefined, minDurationYears: undefined };
    const newValue = { ...base, [f]: v };
    onChange({ weightGain: Object.values(newValue).every(val => typeof val !== 'number') ? 'noCropping' : newValue });
  };

  return (
    <React.Fragment>
      <InlineDiv>{'>\u00A0'}</InlineDiv>
      <InlineDiv>
        <Unit unit={fm('extendedSearch.weightGainThresholdUnitAndLatest')}>
          <InputHandler
            type="NumberField"
            editing={true}
            name="threshold"
            formData={{
              onChange: handleChange,
              document: {
                threshold: typeof thisSearchField === 'object' ? thisSearchField.threshold : undefined,
              },
            }}
            min={1}
            precision={1}
            width={7}
          />
        </Unit>
      </InlineDiv>
      <InlineDiv>
        <InlineDiv>{'≥\u00A0'}</InlineDiv>
        <Unit unit={fm('extendedSearch.weightGainMinDurationYearsBetween')}>
          <InputHandler
            type="NumberField"
            editing={true}
            name="minDurationYears"
            formData={{
              onChange: handleChange,
              document: {
                minDurationYears: typeof thisSearchField === 'object' ? thisSearchField.minDurationYears : undefined,
              },
            }}
            min={1}
            width={7}
          />
        </Unit>
      </InlineDiv>
    </React.Fragment>
  );
};

interface IOwnProps extends Pick<IExtendedSearchField, 'searchFields' | 'onChange'> {}

export default WeightGainField;
